import type {
  CreatePaymentInput,
  ListPaymentsQuery,
  Paginated,
  PatientBalance,
  Payment,
  PaymentHolder,
  ReversePaymentInput,
  Statement,
  StatementQuery,
} from "@clinic/shared";
import { apiDownload, apiRequest } from "@web/shared/lib/api-client";

export const billingApi = {
  balance: (patientId: string): Promise<PatientBalance> =>
    apiRequest(`/patients/${patientId}/balance`),

  statement: (patientId: string, query: StatementQuery): Promise<Statement> =>
    apiRequest(`/patients/${patientId}/statement`, { query: { ...query } }),

  statementPdf: (patientId: string, query: StatementQuery): Promise<Blob> =>
    apiDownload(`/patients/${patientId}/statement.pdf`, { ...query }),

  payments: (query: Partial<ListPaymentsQuery>): Promise<Paginated<Payment>> =>
    apiRequest("/payments", { query: { ...query } }),

  paymentHolders: (): Promise<PaymentHolder[]> => apiRequest("/payments/holders"),

  createPayment: (body: CreatePaymentInput): Promise<Payment> =>
    apiRequest("/payments", { method: "POST", body }),

  reversePayment: (id: string, body: ReversePaymentInput): Promise<Payment> =>
    apiRequest(`/payments/${id}/reverse`, { method: "POST", body }),

  deletePayment: (id: string): Promise<void> => apiRequest(`/payments/${id}`, { method: "DELETE" }),

  receiptPdf: (paymentId: string): Promise<Blob> => apiDownload(`/payments/${paymentId}/receipt`),

  sendReceipt: (paymentId: string, to: string): Promise<void> =>
    apiRequest(`/payments/${paymentId}/receipt/whatsapp`, { method: "POST", body: { to } }),

  sendStatement: (patientId: string, query: StatementQuery, to: string): Promise<void> =>
    apiRequest(`/patients/${patientId}/statement/whatsapp`, {
      method: "POST",
      query: { ...query },
      body: { to },
    }),
};
